import {
  ComponentFeature as componentReducer,
  ComponentPayload,
  setComponentAction,
} from '@smartsheet-dataflow/formjs-react';
import { BridgeFormJSState } from '../../Types';
import { dummyDispatch } from '../ParamFromSchema';

export const reduceComponent =
  (payload: ComponentPayload) => (state: BridgeFormJSState) =>
    componentReducer(state, setComponentAction(dummyDispatch)(payload));
